export const showFirstName = state => state.showFirstName;
